module.exports = __webpack_public_path__ + "img/stock-active.b2d657f5.svg";